import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { TribunaleaAuthProvider } from "@tribunalea/auth/react";
import {
  CreditExhaustionProvider,
  ToastProvider,
} from "@tribunalea/ui";
import App from "./App.jsx";
import "@tribunalea/ui/styles.css";
import "./styles.css";

const apiUrl = import.meta.env.VITE_API_URL || "http://localhost:4000";
const accountCreditsUrl = `${import.meta.env.VITE_ACCOUNT_URL || (
  import.meta.env.DEV
    ? "http://localhost:5175"
    : "https://account.tribunalea.com"
)}/creditos`;

const liveContent = <App authEnabled />;
const demoContent = <App authEnabled={false} />;

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <CreditExhaustionProvider creditsHref={accountCreditsUrl}>
      <ToastProvider>
        <TribunaleaAuthProvider
          publishableKey={import.meta.env.VITE_CLERK_PUBLISHABLE_KEY}
          apiUrl={apiUrl}
          demoFallback={demoContent}
        >
          {liveContent}
        </TribunaleaAuthProvider>
      </ToastProvider>
    </CreditExhaustionProvider>
  </StrictMode>,
);
